// Baked label placements — exported from the hand-placed calibration on 22.08.2026.
// These are the authored truth: every visitor sees them, no localStorage needed.
// Placement in the Explorer still writes localStorage, which overrides the values below
// for that browser only; "Clear" on a marker falls back to the baked position here.
window.CARD_MARKS = {
 "u3_marks_mm1": {
  "8": {
   "side": "A",
   "mx": 27.1,
   "my": 55
  },
  "12": {
   "side": "A",
   "mx": 8.4,
   "my": 8.6
  },
  "15": {
   "side": "B",
   "mx": 80.9,
   "my": 3.4
  },
  "16": {
   "side": "B",
   "mx": 81,
   "my": 51.3
  },
  "20": {
   "side": "A",
   "mx": 41.6,
   "my": 11.3
  },
  "23": {
   "side": "A",
   "mx": 34.6,
   "my": 43.3
  },
  "24": {
   "side": "A",
   "mx": 26.3,
   "my": 23.6
  },
  "25": {
   "side": "A",
   "mx": 11.1,
   "my": 11.2
  },
  "26": {
   "side": "A",
   "mx": 69.6,
   "my": 39.2
  },
  "34": {
   "side": "B",
   "mx": 64.5,
   "my": 40.6
  },
  "35": {
   "side": "B",
   "mx": 42.4,
   "my": 28.7
  },
  "36": {
   "side": "B",
   "mx": 55.5,
   "my": 0
  }
 },
 "u4_marks_v2": {
  "1": {
   "side": "A",
   "mx": 0,
   "my": 0
  },
  "2": {
   "side": "A",
   "mx": 33.6,
   "my": 0
  },
  "3": {
   "side": "A",
   "mx": 25.7,
   "my": 22.3
  },
  "4": {
   "side": "A",
   "mx": 32.8,
   "my": 9.6
  },
  "5": {
   "side": "A",
   "mx": 47.6,
   "my": 8.9
  },
  "6": {
   "side": "A",
   "mx": 0,
   "my": 0
  },
  "7": {
   "side": "A",
   "mx": 0,
   "my": 7.1
  },
  "8": {
   "side": "A",
   "mx": 34.3,
   "my": 23.5
  },
  "9": {
   "side": "A",
   "mx": 24.3,
   "my": 29.5
  },
  "10": {
   "side": "A",
   "mx": 46.1,
   "my": 42.1
  },
  "11": {
   "side": "A",
   "mx": 0,
   "my": 43.9
  },
  "12": {
   "side": "A",
   "mx": 0,
   "my": 50.8
  },
  "13": {
   "side": "A",
   "mx": 4.9,
   "my": 49
  },
  "14": {
   "side": "A",
   "mx": 24.7,
   "my": 44.5
  },
  "15": {
   "side": "B",
   "mx": 49.2,
   "my": 7
  },
  "16": {
   "side": "B",
   "mx": 27.1,
   "my": 10.3
  },
  "17": {
   "side": "B",
   "mx": 0,
   "my": 11.7
  },
  "18": {
   "side": "B",
   "mx": 20.2,
   "my": 17.7
  },
  "19": {
   "side": "B",
   "mx": 0,
   "my": 33.7
  },
  "20": {
   "side": "B",
   "mx": 14.7,
   "my": 8.7
  },
  "21": {
   "side": "B",
   "mx": 17.2,
   "my": 38.5
  },
  "22": {
   "side": "B",
   "mx": 32.8,
   "my": 55
  },
  "23": {
   "side": "B",
   "mx": 4.5,
   "my": 51.4
  },
  "24": {
   "side": "B",
   "mx": 8.4,
   "my": 13.8
  },
  "25": {
   "side": "B",
   "mx": 0,
   "my": 54.2
  },
  "26": {
   "side": "B",
   "mx": 42.4,
   "my": 55
  },
  "27": {
   "side": "A",
   "mx": 80.9,
   "my": 0
  },
  "28": {
   "side": "A",
   "mx": 84.1,
   "my": 3.3
  },
  "29": {
   "side": "A",
   "mx": 85,
   "my": 6.6
  },
  "30": {
   "side": "A",
   "mx": 85,
   "my": 13.4
  },
  "31": {
   "side": "A",
   "mx": 85,
   "my": 30.8
  },
  "32": {
   "side": "A",
   "mx": 85,
   "my": 25.4
  },
  "33": {
   "side": "A",
   "mx": 64.3,
   "my": 27.3
  },
  "34": {
   "side": "A",
   "mx": 60.1,
   "my": 42.4
  },
  "35": {
   "side": "A",
   "mx": 85,
   "my": 36.5
  },
  "36": {
   "side": "A",
   "mx": 69.2,
   "my": 38.5
  },
  "37": {
   "side": "A",
   "mx": 68.4,
   "my": 42.1
  },
  "38": {
   "side": "A",
   "mx": 76.9,
   "my": 52.1
  },
  "39": {
   "side": "A",
   "mx": 83.8,
   "my": 50.6
  },
  "40": {
   "side": "A",
   "mx": 59.8,
   "my": 55
  },
  "41": {
   "side": "A",
   "mx": 48.8,
   "my": 55
  },
  "42": {
   "side": "A",
   "mx": 30.3,
   "my": 55
  },
  "43": {
   "side": "A",
   "mx": 36.1,
   "my": 55
  },
  "44": {
   "side": "B",
   "mx": 52.7,
   "my": 0
  },
  "45": {
   "side": "B",
   "mx": 71.5,
   "my": 8.4
  },
  "46": {
   "side": "B",
   "mx": 78,
   "my": 7.2
  },
  "47": {
   "side": "B",
   "mx": 76.2,
   "my": 12.1
  },
  "48": {
   "side": "B",
   "mx": 45.5,
   "my": 8.5
  },
  "49": {
   "side": "B",
   "mx": 40.9,
   "my": 28.8
  },
  "50": {
   "side": "B",
   "mx": 37.2,
   "my": 43.3
  },
  "51": {
   "side": "B",
   "mx": 46.5,
   "my": 42.3
  },
  "52": {
   "side": "B",
   "mx": 76.5,
   "my": 40.8
  },
  "53": {
   "side": "B",
   "mx": 82.1,
   "my": 45.3
  },
  "54": {
   "side": "B",
   "mx": 85,
   "my": 50.5
  },
  "55": {
   "side": "B",
   "mx": 65.1,
   "my": 50
  },
  "56": {
   "side": "B",
   "mx": 65.7,
   "my": 48.8
  },
  "57": {
   "side": "B",
   "mx": 42.1,
   "my": 55
  }
 },
 "u5_marks_v5": {
  "1": {
   "side": "A",
   "mx": 31,
   "my": 10.9
  },
  "2": {
   "side": "A",
   "mx": 46.2,
   "my": 12.1
  },
  "3": {
   "side": "A",
   "mx": 28.7,
   "my": 26
  },
  "4": {
   "side": "B",
   "mx": 38.7,
   "my": 11.7
  },
  "5": {
   "side": "A",
   "mx": 67.4,
   "my": 35.9
  },
  "6": {
   "side": "A",
   "mx": 70.7,
   "my": 39.4
  },
  "7": {
   "side": "B",
   "mx": 67.6,
   "my": 9.5
  },
  "8": {
   "side": "B",
   "mx": 75.7,
   "my": 7.9
  },
  "9": {
   "side": "B",
   "mx": 75.7,
   "my": 14.1
  },
  "10": {
   "side": "B",
   "mx": 74.5,
   "my": 40.2
  },
  "11": {
   "side": "B",
   "mx": 65.8,
   "my": 48.5
  },
  "12": {
   "side": "A",
   "mx": 0,
   "my": 5.7
  },
  "13": {
   "side": "A",
   "mx": 0,
   "my": 45.4
  },
  "14": {
   "side": "A",
   "mx": 0.9,
   "my": 55.4
  },
  "15": {
   "side": "A",
   "mx": 10.8,
   "my": 54.2
  },
  "16": {
   "side": "A",
   "mx": 19.8,
   "my": 49.2
  },
  "17": {
   "side": "A",
   "mx": 81,
   "my": 0
  },
  "18": {
   "side": "A",
   "mx": 85.4,
   "my": 3.4
  },
  "19": {
   "side": "A",
   "mx": 85.4,
   "my": 8.1
  },
  "20": {
   "side": "A",
   "mx": 85.4,
   "my": 24.9
  },
  "21": {
   "side": "A",
   "mx": 85.4,
   "my": 30.3
  },
  "22": {
   "side": "A",
   "mx": 85.4,
   "my": 36
  },
  "23": {
   "side": "A",
   "mx": 83.5,
   "my": 55.4
  },
  "24": {
   "side": "B",
   "mx": 67.7,
   "my": 51.4
  },
  "25": {
   "side": "A",
   "mx": 41.5,
   "my": 55.4
  },
  "26": {
   "side": "A",
   "mx": 85.4,
   "my": 42.6
  },
  "27": {
   "side": "A",
   "mx": 72.7,
   "my": 55.4
  },
  "28": {
   "side": "A",
   "mx": 38.8,
   "my": 0
  },
  "29": {
   "side": "B",
   "mx": 55.9,
   "my": 0
  },
  "30": {
   "side": "A",
   "mx": 44.4,
   "my": 42.3
  },
  "31": {
   "side": "B",
   "mx": 26.7,
   "my": 8.8
  },
  "32": {
   "side": "B",
   "mx": 0,
   "my": 20.6
  },
  "33": {
   "side": "B",
   "mx": 30.5,
   "my": 55.4
  },
  "34": {
   "side": "A",
   "mx": 61.5,
   "my": 28.7
  },
  "35": {
   "side": "A",
   "mx": 66.8,
   "my": 42.5
  },
  "36": {
   "side": "A",
   "mx": 77.4,
   "my": 52.1
  },
  "37": {
   "side": "B",
   "mx": 41,
   "my": 0
  },
  "38": {
   "side": "B",
   "mx": 40.5,
   "my": 41.8
  },
  "39": {
   "side": "B",
   "mx": 84.8,
   "my": 45.4
  },
  "40": {
   "side": "B",
   "mx": 0,
   "my": 5.8
  },
  "41": {
   "side": "B",
   "mx": 15.4,
   "my": 17.3
  },
  "42": {
   "side": "B",
   "mx": 0,
   "my": 33.8
  },
  "43": {
   "side": "B",
   "mx": 4.4,
   "my": 51.5
  },
  "44": {
   "side": "B",
   "mx": 7.9,
   "my": 10.7
  },
  "45": {
   "side": "A",
   "mx": 27,
   "my": 55.4
  },
  "46": {
   "side": "A",
   "mx": 33.2,
   "my": 55.4
  },
  "47": {
   "side": "B",
   "mx": 42.3,
   "my": 30.2
  },
  "48": {
   "side": "B",
   "mx": 48.5,
   "my": 41.5
  },
  "49": {
   "side": "B",
   "mx": 78.3,
   "my": 55.4
  }
 },
 "ex_marks_mm1": {
  "1": {
   "side": "A",
   "mx": 14.5,
   "my": 1.6
  },
  "2": {
   "side": "A",
   "mx": 1.3,
   "my": 0.2
  },
  "3": {
   "side": "A",
   "mx": 0,
   "my": 6.3
  },
  "4": {
   "side": "A",
   "mx": 8.7,
   "my": 0
  },
  "5": {
   "side": "A",
   "mx": 43.4,
   "my": 26.1
  },
  "6": {
   "side": "A",
   "mx": 10.5,
   "my": 25.6
  },
  "7": {
   "side": "A",
   "mx": 0,
   "my": 49.7
  },
  "8": {
   "side": "A",
   "mx": 39.1,
   "my": 45.5
  },
  "9": {
   "side": "A",
   "mx": 18.6,
   "my": 55.2
  },
  "10": {
   "side": "A",
   "mx": 21.9,
   "my": 15.9
  },
  "11": {
   "side": "B",
   "mx": 44.7,
   "my": 9.5
  },
  "12": {
   "side": "B",
   "mx": 12.6,
   "my": 12.9
  },
  "13": {
   "side": "B",
   "mx": 0,
   "my": 41.5
  },
  "14": {
   "side": "B",
   "mx": 0,
   "my": 55.2
  },
  "15": {
   "side": "B",
   "mx": 23.1,
   "my": 55.2
  },
  "16": {
   "side": "A",
   "mx": 69.5,
   "my": 0
  },
  "17": {
   "side": "A",
   "mx": 62.6,
   "my": 4.9
  },
  "18": {
   "side": "A",
   "mx": 87.4,
   "my": 18.9
  },
  "19": {
   "side": "A",
   "mx": 71.6,
   "my": 28.3
  },
  "20": {
   "side": "A",
   "mx": 72.5,
   "my": 41.5
  },
  "21": {
   "side": "A",
   "mx": 59.6,
   "my": 55.2
  },
  "22": {
   "side": "B",
   "mx": 70.6,
   "my": 2.9
  },
  "23": {
   "side": "B",
   "mx": 69.4,
   "my": 5.5
  },
  "24": {
   "side": "B",
   "mx": 65.4,
   "my": 9
  },
  "25": {
   "side": "B",
   "mx": 75.6,
   "my": 44.9
  },
  "26": {
   "side": "B",
   "mx": 58.8,
   "my": 39.4
  }
 },
 "adv_marks_mm1": {
  "1": {
   "side": "A",
   "mx": 35.1,
   "my": 0
  },
  "2": {
   "side": "A",
   "mx": 29.9,
   "my": 6.8
  },
  "3": {
   "side": "A",
   "mx": 13.9,
   "my": 28.3
  },
  "4": {
   "side": "A",
   "mx": 0,
   "my": 32.7
  },
  "8": {
   "side": "A",
   "mx": 83.7,
   "my": 28.1
  },
  "9": {
   "side": "B",
   "mx": 11.6,
   "my": 10.4
  },
  "11": {
   "side": "B",
   "mx": 64.2,
   "my": 31.8
  },
  "16": {
   "side": "A",
   "mx": 75.4,
   "my": 19.6
  },
  "18": {
   "side": "A",
   "mx": 72.7,
   "my": 45.5
  },
  "22": {
   "side": "B",
   "mx": 53.1,
   "my": 0
  }
 },
 "bush_marks_mm1": {
  "1": {
   "side": "A",
   "mx": 36.6,
   "my": 9.8
  },
  "2": {
   "side": "A",
   "mx": 0,
   "my": 12.5
  },
  "4": {
   "side": "A",
   "mx": 83.4,
   "my": 55
  },
  "5": {
   "side": "A",
   "mx": 65.9,
   "my": 51.2
  },
  "6": {
   "side": "A",
   "mx": 83.7,
   "my": 29.9
  },
  "7": {
   "side": "A",
   "mx": 84.1,
   "my": 22.9
  },
  "8": {
   "side": "A",
   "mx": 84.3,
   "my": 16.4
  },
  "9": {
   "side": "B",
   "mx": 1.6,
   "my": 27.2
  },
  "10": {
   "side": "B",
   "mx": 18.5,
   "my": 26.9
  },
  "11": {
   "side": "B",
   "mx": 38.6,
   "my": 31
  },
  "12": {
   "side": "A",
   "mx": 8.4,
   "my": 23.5
  }
 },
 "dsn_marks_mm1": {
  "1": {
   "side": "A",
   "mx": 45.9,
   "my": 54
  },
  "2": {
   "side": "A",
   "mx": 33,
   "my": 0.5
  },
  "4": {
   "side": "A",
   "mx": 11.3,
   "my": 46.1
  },
  "5": {
   "side": "A",
   "mx": 2,
   "my": 49.1
  },
  "7": {
   "side": "B",
   "mx": 1.3,
   "my": 1.7
  },
  "8": {
   "side": "B",
   "mx": 0,
   "my": 54
  },
  "10": {
   "side": "A",
   "mx": 43.3,
   "my": 19.2
  },
  "11": {
   "side": "A",
   "mx": 83.6,
   "my": 23.6
  },
  "12": {
   "side": "A",
   "mx": 79.1,
   "my": 47
  },
  "13": {
   "side": "B",
   "mx": 68.8,
   "my": 4.2
  }
 },
 "prof_marks_mm1": {
  "1": {
   "side": "A",
   "mx": 48.8,
   "my": 0
  },
  "2": {
   "side": "A",
   "mx": 0,
   "my": 0
  },
  "4": {
   "side": "A",
   "mx": 19.6,
   "my": 10.1
  },
  "5": {
   "side": "A",
   "mx": 70.6,
   "my": 46.8
  },
  "6": {
   "side": "A",
   "mx": 0,
   "my": 51.8
  },
  "7": {
   "side": "B",
   "mx": 46.2,
   "my": 0
  },
  "8": {
   "side": "B",
   "mx": 45.4,
   "my": 0
  },
  "9": {
   "side": "B",
   "mx": 14.6,
   "my": 15.1
  },
  "10": {
   "side": "B",
   "mx": 0,
   "my": 53.2
  },
  "11": {
   "side": "B",
   "mx": 72.5,
   "my": 45.5
  },
  "13": {
   "side": "A",
   "mx": 76.9,
   "my": 5.3
  },
  "14": {
   "side": "A",
   "mx": 55.4,
   "my": 0
  },
  "15": {
   "side": "A",
   "mx": 87.1,
   "my": 13.5
  },
  "16": {
   "side": "A",
   "mx": 44.1,
   "my": 19.6
  },
  "17": {
   "side": "A",
   "mx": 85.5,
   "my": 49.9
  },
  "19": {
   "side": "A",
   "mx": 87.1,
   "my": 54
  },
  "20": {
   "side": "B",
   "mx": 1.2,
   "my": 6.8
  },
  "22": {
   "side": "B",
   "mx": 87.1,
   "my": 18.6
  }
 },
 "ow_marks_v3": {
  "1": {
   "side": "A",
   "mx": 51.1,
   "my": 0
  },
  "2": {
   "side": "B",
   "mx": 47.9,
   "my": 0
  },
  "3": {
   "side": "A",
   "mx": 0,
   "my": 27.2
  },
  "4": {
   "side": "A",
   "mx": 42.5,
   "my": 27.5
  },
  "5": {
   "side": "B",
   "mx": 85,
   "my": 39
  },
  "6": {
   "side": "A",
   "mx": 0,
   "my": 0
  },
  "7": {
   "side": "B",
   "mx": 85,
   "my": 0
  },
  "8": {
   "side": "A",
   "mx": 9.6,
   "my": 12.7
  },
  "9": {
   "side": "A",
   "mx": 8.4,
   "my": 30.1
  },
  "10": {
   "side": "A",
   "mx": 14.1,
   "my": 39
  },
  "11": {
   "side": "A",
   "mx": 75.5,
   "my": 35.6
  },
  "12": {
   "side": "A",
   "mx": 80.3,
   "my": 0
  },
  "13": {
   "side": "A",
   "mx": 71.3,
   "my": 38.6
  },
  "14": {
   "side": "A",
   "mx": 78.4,
   "my": 54.8
  },
  "15": {
   "side": "A",
   "mx": 65.3,
   "my": 48
  },
  "16": {
   "side": "A",
   "mx": 83.5,
   "my": 54.2
  },
  "17": {
   "side": "A",
   "mx": 68.6,
   "my": 55
  },
  "18": {
   "side": "B",
   "mx": 8.2,
   "my": 24.3
  },
  "19": {
   "side": "A",
   "mx": 0,
   "my": 32.8
  },
  "20": {
   "side": "A",
   "mx": 0,
   "my": 55
  },
  "21": {
   "side": "A",
   "mx": 85,
   "my": 53.6
  },
  "22": {
   "side": "B",
   "mx": 0,
   "my": 19.7
  }
 },
 "u4_photo_pct1": {
  "1": {
   "side": "A",
   "x": 2.1,
   "y": 29
  },
  "2": {
   "side": "A",
   "x": 32.7,
   "y": 25
  },
  "3": {
   "side": "A",
   "x": 22.6,
   "y": 51
  },
  "4": {
   "side": "A",
   "x": 34.9,
   "y": 34.6
  },
  "5": {
   "side": "A",
   "x": 43.3,
   "y": 35
  },
  "6": {
   "side": "A",
   "x": 2.3,
   "y": 29.6
  },
  "7": {
   "side": "A",
   "x": 2.7,
   "y": 39.4
  },
  "8": {
   "side": "A",
   "x": 27.2,
   "y": 49.7
  },
  "9": {
   "side": "A",
   "x": 35,
   "y": 54.6
  },
  "10": {
   "side": "A",
   "x": 46,
   "y": 66.7
  },
  "11": {
   "side": "A",
   "x": 8.7,
   "y": 76.3
  },
  "12": {
   "side": "A",
   "x": 9.1,
   "y": 87.8
  },
  "13": {
   "side": "A",
   "x": 17.6,
   "y": 83
  },
  "14": {
   "side": "A",
   "x": 25.7,
   "y": 75.8
  },
  "16": {
   "side": "B",
   "x": 40,
   "y": 26.3
  },
  "17": {
   "side": "B",
   "x": 28,
   "y": 13.5
  },
  "18": {
   "side": "B",
   "x": 35.2,
   "y": 26.7
  },
  "19": {
   "side": "B",
   "x": 20.7,
   "y": 26.9
  },
  "20": {
   "side": "B",
   "x": 30.5,
   "y": 62.2
  },
  "21": {
   "side": "B",
   "x": 26.2,
   "y": 40.5
  },
  "22": {
   "side": "B",
   "x": 22,
   "y": 17.6
  },
  "23": {
   "side": "B",
   "x": 15.3,
   "y": 45.4
  },
  "25": {
   "side": "B",
   "x": 14.3,
   "y": 45
  },
  "26": {
   "side": "B",
   "x": 36.4,
   "y": 66.8
  },
  "27": {
   "side": "A",
   "x": 64.3,
   "y": 20.4
  },
  "28": {
   "side": "A",
   "x": 67.6,
   "y": 22.5
  },
  "29": {
   "side": "A",
   "x": 70,
   "y": 25.8
  },
  "30": {
   "side": "A",
   "x": 71.1,
   "y": 35.3
  },
  "31": {
   "side": "A",
   "x": 72.4,
   "y": 37
  },
  "32": {
   "side": "A",
   "x": 74.1,
   "y": 42.9
  },
  "33": {
   "side": "A",
   "x": 57.5,
   "y": 51.2
  },
  "34": {
   "side": "A",
   "x": 65.1,
   "y": 51.2
  },
  "35": {
   "side": "A",
   "x": 75.3,
   "y": 48.7
  },
  "36": {
   "side": "A",
   "x": 62.4,
   "y": 58.9
  },
  "37": {
   "side": "A",
   "x": 64,
   "y": 63
  },
  "38": {
   "side": "A",
   "x": 73.9,
   "y": 73.4
  },
  "39": {
   "side": "A",
   "x": 78.2,
   "y": 73.5
  },
  "40": {
   "side": "A",
   "x": 65.3,
   "y": 81
  },
  "41": {
   "side": "A",
   "x": 48.1,
   "y": 80.8
  },
  "42": {
   "side": "A",
   "x": 33.9,
   "y": 83
  },
  "43": {
   "side": "A",
   "x": 38.9,
   "y": 82.4
  },
  "44": {
   "side": "B",
   "x": 58,
   "y": 24.2
  },
  "45": {
   "side": "B",
   "x": 66.2,
   "y": 39
  },
  "46": {
   "side": "B",
   "x": 72.5,
   "y": 41.1
  },
  "47": {
   "side": "B",
   "x": 67.8,
   "y": 48.5
  },
  "49": {
   "side": "B",
   "x": 40.3,
   "y": 43.1
  },
  "50": {
   "side": "B",
   "x": 38.4,
   "y": 53
  },
  "51": {
   "side": "B",
   "x": 44.3,
   "y": 57
  },
  "52": {
   "side": "B",
   "x": 57.3,
   "y": 66.5
  },
  "53": {
   "side": "B",
   "x": 63.1,
   "y": 76.4
  },
  "54": {
   "side": "B",
   "x": 59.6,
   "y": 80.1
  },
  "55": {
   "side": "B",
   "x": 50.5,
   "y": 68.3
  },
  "56": {
   "side": "B",
   "x": 51,
   "y": 69
  },
  "57": {
   "side": "B",
   "x": 35.8,
   "y": 65.1
  }
 },
 "dsn_photo_pct1": {
  "6": {
   "side": "B",
   "x": 75,
   "y": 39.1
  },
  "7": {
   "side": "B",
   "x": 51.3,
   "y": 5.7
  },
  "8": {
   "side": "B",
   "x": 9.8,
   "y": 12.7
  },
  "9": {
   "side": "B",
   "x": 39.6,
   "y": 78.8
  },
  "13": {
   "side": "B",
   "x": 73.6,
   "y": 54.9
  },
  "14": {
   "side": "B",
   "x": 31.6,
   "y": 57.1
  },
  "15": {
   "side": "B",
   "x": 22.4,
   "y": 60.9
  }
 }
};
